// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-sidebar-MobileSidebar-module__sidebar {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.src-sidebar-MobileSidebar-module__background {
    pointer-events: all; /* we want all the content to behave normally*/
    background-color: white;
}

.src-sidebar-MobileSidebar-module__fullHeight {
    height: 100%;
}

.src-sidebar-MobileSidebar-module__addressSearch {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    padding: 0.5rem;
}

.src-sidebar-MobileSidebar-module__addressInputContainer {
    flex-grow: 1;
}

.src-sidebar-MobileSidebar-module__mapView {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.src-sidebar-MobileSidebar-module__mapViewRow {
    display: flex;
    flex-direction: row;
}

.src-sidebar-MobileSidebar-module__queryPointText {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #5b616a;
}

.src-sidebar-MobileSidebar-module__queryPointTextTo {
    font-size: large;
    font-weight: bold;
    color: inherit;
}

.src-sidebar-MobileSidebar-module__queryPointTextVia {
    font-size: small;
}

.src-sidebar-MobileSidebar-module__markerContainer {
    align-self: center;
    justify-self: center;
    width: 0.6rem;
    margin-right: 0.5rem;
    flex-shrink: 0;
}

.src-sidebar-MobileSidebar-module__markerContainer > svg {
    width: 100%;
    height: 100%;
    display: block;
}

.src-sidebar-MobileSidebar-module__btnCloseContainer {
    display: flex;
    flex-direction: column;
}

.src-sidebar-MobileSidebar-module__btnCloseInputs svg {
    width: 34px;
    color: #adadad;
}

.src-sidebar-MobileSidebar-module__btnCloseInputs {
    z-index: 0; /* without it the button isn't clickable */
    position: absolute;
    top: 10px;
    right: 1px;
}

.src-sidebar-MobileSidebar-module__btnOpenContainer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    padding: 0.25rem 0.5rem;
    border: 1px black solid;
    margin: 0.5rem;
    border-radius: 0.2rem;
}

.src-sidebar-MobileSidebar-module__btnOpenContainer .src-sidebar-MobileSidebar-module__mapView {
    width: calc(100% - 34px);
}

.src-sidebar-MobileSidebar-module__btnOpenInputs svg {
    color: #adadad;
}

.src-sidebar-MobileSidebar-module__btnOpenInputs {
    width: 34px;
}
`, "",{"version":3,"sources":["webpack://./src/sidebar/MobileSidebar.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB,EAAE,8CAA8C;IACnE,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,UAAU,EAAE,0CAA0C;IACtD,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,uBAAuB;IACvB,uBAAuB;IACvB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".sidebar {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.background {\n    pointer-events: all; /* we want all the content to behave normally*/\n    background-color: white;\n}\n\n.fullHeight {\n    height: 100%;\n}\n\n.addressSearch {\n    display: flex;\n    flex-direction: row;\n    gap: 0.5rem;\n    padding: 0.5rem;\n}\n\n.addressInputContainer {\n    flex-grow: 1;\n}\n\n.mapView {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.mapViewRow {\n    display: flex;\n    flex-direction: row;\n}\n\n.queryPointText {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: #5b616a;\n}\n\n.queryPointTextTo {\n    font-size: large;\n    font-weight: bold;\n    color: inherit;\n}\n\n.queryPointTextVia {\n    font-size: small;\n}\n\n.markerContainer {\n    align-self: center;\n    justify-self: center;\n    width: 0.6rem;\n    margin-right: 0.5rem;\n    flex-shrink: 0;\n}\n\n.markerContainer > svg {\n    width: 100%;\n    height: 100%;\n    display: block;\n}\n\n.btnCloseContainer {\n    display: flex;\n    flex-direction: column;\n}\n\n.btnCloseInputs svg {\n    width: 34px;\n    color: #adadad;\n}\n\n.btnCloseInputs {\n    z-index: 0; /* without it the button isn't clickable */\n    position: absolute;\n    top: 10px;\n    right: 1px;\n}\n\n.btnOpenContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n\n    padding: 0.25rem 0.5rem;\n    border: 1px black solid;\n    margin: 0.5rem;\n    border-radius: 0.2rem;\n}\n\n.btnOpenContainer .mapView {\n    width: calc(100% - 34px);\n}\n\n.btnOpenInputs svg {\n    color: #adadad;\n}\n\n.btnOpenInputs {\n    width: 34px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `src-sidebar-MobileSidebar-module__sidebar`,
	"background": `src-sidebar-MobileSidebar-module__background`,
	"fullHeight": `src-sidebar-MobileSidebar-module__fullHeight`,
	"addressSearch": `src-sidebar-MobileSidebar-module__addressSearch`,
	"addressInputContainer": `src-sidebar-MobileSidebar-module__addressInputContainer`,
	"mapView": `src-sidebar-MobileSidebar-module__mapView`,
	"mapViewRow": `src-sidebar-MobileSidebar-module__mapViewRow`,
	"queryPointText": `src-sidebar-MobileSidebar-module__queryPointText`,
	"queryPointTextTo": `src-sidebar-MobileSidebar-module__queryPointTextTo`,
	"queryPointTextVia": `src-sidebar-MobileSidebar-module__queryPointTextVia`,
	"markerContainer": `src-sidebar-MobileSidebar-module__markerContainer`,
	"btnCloseContainer": `src-sidebar-MobileSidebar-module__btnCloseContainer`,
	"btnCloseInputs": `src-sidebar-MobileSidebar-module__btnCloseInputs`,
	"btnOpenContainer": `src-sidebar-MobileSidebar-module__btnOpenContainer`,
	"btnOpenInputs": `src-sidebar-MobileSidebar-module__btnOpenInputs`
};
export default ___CSS_LOADER_EXPORT___;
